import React, { useState, useEffect } from "react";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Card, Button, Form, Spinner,Col,Row,Container  } from 'react-bootstrap';
import { useSelector } from "react-redux";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ClipLoader } from 'react-spinners';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

const BoardDashboard = () => {
  
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const [startDate, setStartDate] = useState(firstDayOfMonth);
  const [endDate, setEndDate] = useState(lastDayOfMonth);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(5); // State to hold the countdown timer

  const COLORS = [
    '#007bff', // Primary
    '#6c757d', // Secondary
    '#28a745', // Success
    '#dc3545', // Danger
    '#ffc107', // Warning
    '#17a2b8'  // Info
  ];

  
  
  const { user: currentUser } = useSelector((state) => state.auth);
  
   let dynText = "";
 
   if(currentUser.roles.includes("ROLE_ADMIN") )
    {
      dynText = "WILLKOMMEN DYN ADMIN";
    }
    else if(currentUser.roles.includes("ROLE_CUSTOMER") )
    {
      dynText = "WILLKOMMEN DYN KUNDE";
    }
    else if(currentUser.roles.includes("ROLE_EMPLOYEE") )
    {
      dynText = "WILLKOMMEN DYN MITARBEITER";
    }
    else if(currentUser.roles.includes("ROLE_MAINVO") )
    {
      dynText = "WILLKOMMEN DYN MAINVO";
    }
    else if(currentUser.roles.includes("ROLE_SUBVO") )
    {
      dynText = "WILLKOMMEN DYN SUBVO";
    }

  const fetchFilteredData = async () => {
    setLoading(true);
    try {
      const response = await UserService.getDashboard({
        startDate: startDate.toISOString().split('T')[0],
        endDate: endDate.toISOString().split('T')[0],
      });

      console.log('Data fetched successfully:', response.data);

      // Ensure response data is valid and is an array
      if (Array.isArray(response.data)) {
        setData(response.data);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error('Error fetching data', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Interval to fetch data every 5 seconds
    const dataInterval = setInterval(() => {
      fetchFilteredData();
      setCountdown(5); // Reset countdown after every data refresh
    }, 5000);

    // Interval to update countdown every second
    const countdownInterval = setInterval(() => {
      setCountdown(prevCountdown => (prevCountdown > 0 ? prevCountdown - 1 : 5));
    }, 1000);

    // Cleanup function to clear intervals on unmount
    return () => {
      clearInterval(dataInterval);
      clearInterval(countdownInterval);
    };
  }, []);

  return (
    <div className="container mt-3 text-center">
      <div className="info-panel">
      <h2>Echtzeit-Infopanel</h2>
      
        <div className="loading-container">
          <ClipLoader color="#36d7b7" loading={loading} size={50} />
          <p style={{ marginLeft: '10px' }}>Aktualisierung in {countdown} Sekunden...</p>
        </div>
        </div>
      
      <h2>Tägliche Weiterleitungsübersicht</h2>

      {/* Date Picker Filters */}
      <Form inline className="d-flex justify-content-center mb-4">
        <Form.Group>
          <Form.Label className="mr-2">Startdatum:</Form.Label>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
            className="mr-4"
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="mr-2">Enddatum:</Form.Label>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            dateFormat="yyyy-MM-dd"
          />
        </Form.Group>
        <Button variant="primary" className="ml-4" onClick={fetchFilteredData} disabled={loading}>
          {loading ? 'Wird geladen...' : 'Filtern'}
        </Button>
      </Form>

      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      ) : data.length > 0 ? (
        <>
       <Container>
          <Row>
            {/* First Row with 2 columns */}
            <Col md={6} className="mb-4">
              <Card>
                <Card.Header as="h2" className="text-center">Weiterleitungen nach Kunde</Card.Header>
                <Card.Body>
                  <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                      <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={({ name, value }) => `${name}: ${value}`}
                        outerRadius={100}
                        fill="#8884d8"
                        dataKey="batch_count"
                        nameKey="customerCompanyName"
                      >
                        {data.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  </ResponsiveContainer>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} className="mb-4">
              <Card>
                <Card.Header as="h2" className="text-center">Weiterleitungen nach Mitarbeiter</Card.Header>
                <Card.Body>
                  <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                      <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={({ name, value }) => `${name}: ${value}`}
                        outerRadius={100}
                        fill="#8884d8"
                        dataKey="batch_count"
                        nameKey="employeeName"
                      >
                        {data.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  </ResponsiveContainer>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            {/* Second Row with 2 columns */}
            <Col md={6} className="mb-4">
              <Card>
                <Card.Header as="h2" className="text-center">Weiterleitungen nach Sub-VOs</Card.Header>
                <Card.Body>
                  <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                      <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={({ name, value }) => `${name}: ${value}`}
                        outerRadius={100}
                        fill="#8884d8"
                        dataKey="batch_count"
                        nameKey="subvoCompanyName"
                      >
                        {data.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  </ResponsiveContainer>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} className="mb-4">
              <Card>
                <Card.Header as="h2" className="text-center">Weiterleitungen nach Haupt-VOs</Card.Header>
                <Card.Body>
                  <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                      <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={({ name, value }) => `${name}: ${value}`}
                        outerRadius={100}
                        fill="#8884d8"
                        dataKey="batch_count"
                        nameKey="mainvoCompanyName"
                      >
                        {data.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip />
                      <Legend />
                    </PieChart>
                  </ResponsiveContainer>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        </>
      ) : (
        <p>Für den ausgewählten Zeitraum sind keine Daten verfügbar.</p>
      )}
    </div>
  );
};

export default BoardDashboard;